module.exports = __webpack_public_path__ + "9103ed6766229c2e3d7a2688fe239078.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/graphics/api-graphic.png
// module id = 614
// module chunks = 0